<template>
    <div class="class-alert" v-if="classAlert" :class="alertLevel"> 

        <router-link :to="{ name: 'course', params: { courseId: course.instanceid }}">
        <h5>{{course.name}}</h5>
        <!-- TODO: add meeting link -->
        <span v-if="classAlert==='inSession'">In Session</span>
        <span v-else> starting in {{setClassAlert}}</span> </router-link>

        </div>
</template>

<script>

import moment from 'moment';
import momentTimezone from 'moment-timezone';
import countdown from 'countdown';

export default {
    props:['course'],
    data() {
        return {
            classAlert: null,
            alertLevel:null
        };
    },
    mounted() {
        var self = this;
        this.startClassAlert();
        window.setInterval(function() {
            self.startClassAlert();   
        },60000);
         
    },
    computed: {
        setClassAlert: function() {
            return this.classAlert;
        }
    },
    methods: {
        startClassAlert: function() {

            function convertTo24Hour(time) {
                var hours = parseInt(time.substr(0, 2));
                if (time.indexOf('am') != -1 && hours == 12) {
                    time = time.replace('12', '0');
                }
                if (time.indexOf('pm') != -1 && hours < 12) {
                    time = time.replace(hours, (hours + 12));
                }
                return time.replace(/(am|pm)/, '');
            }

            function getNextClassDay(start) {
                for (var i = start; i < 7; i++) {
                    if (classDays.indexOf(days[i]) > -1) {
                        return i;
                    }
                }
            }
            var days = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
            var today = moment().format('dd').toUpperCase();
            var startIndex = days.indexOf(today);

            var classDays = $.map(this.course.schedule.weekdays, function(value, index) {
                return [value];
            });

            classDays = classDays[0];

            var nextClassDay = null;
            var nextClass;
   
            // check if there's a class upcoming this week
            nextClassDay = getNextClassDay(moment().isoWeekday());
            // if no upcoming class this week, see what day the first class in the week falls on

            var start = convertTo24Hour(this.course.schedule.start_time).split(':');
            var end = convertTo24Hour(this.course.schedule.end_time).split(':');

            if (!nextClassDay) {
                nextClassDay = getNextClassDay(0);
            }
            if ( (moment().isoWeekday() == nextClassDay) && (parseInt(end.join(''),10) < parseInt(moment().format('HHHH'))) ) {
                // class was today, but now it's over
                nextClass = moment().add(1, 'weeks').isoWeekday(nextClassDay).toDate();
            }
            else if (moment().isoWeekday() <= nextClassDay) { 
              // class is happening later this week, or today, but hasn't happened yet
              nextClass = moment().isoWeekday(nextClassDay).toDate();
            } else {
              // class is happening next week
              nextClass = moment().add(1, 'weeks').isoWeekday(nextClassDay).toDate();
            };

          
            var rightNow = moment.utc();

            var VancouverTime = moment.tz.zone('America/Vancouver').offset(rightNow);
            var UserTime = moment.tz.zone(moment.tz.guess()).offset(rightNow);
            var minutesDifference = (VancouverTime - UserTime);
            var hours = parseInt(minutesDifference / 60)
            var minutes = minutesDifference % 60;
   
            // may be positive or negative hours
            nextClass.setHours( (parseInt(hours, 10) + parseInt(start[0], 10)), parseInt(minutes,10) + parseInt(start[1],10), 0);

            var diff = countdown(null, nextClass, 
            countdown.DAYS | countdown.HOURS | countdown.MINUTES);

            if (diff.value < 0) {                
                this.classAlert = 'inSession'
            } else {
                var secondsRemaining = diff.value / 1000;
                
                if ( secondsRemaining < 3600) this.alertLevel = 'red'; // class starts in less than an hour           
                else if ( secondsRemaining < 86400) this.alertLevel = 'yellow'; // class starts today
                else this.alertLevel = 'green'; 

                this.classAlert = diff.toString();
            }

        }
    }
}
    </script>


<style lang="scss">
.class-alert {
    margin-bottom:1rem;
    border-left:5px solid;
    padding-left:.75rem;
    &.red {
        border-color:red;
        box-shadow: -4px 0px 4px -3px red;
    }
    &.yellow {
        border-color:#fec907;
        box-shadow: -4px 0px 4px -3px #fec907;
    }
    &.green {
        border-color:green;
        box-shadow: -4px 0px 4px -3px green;
    }
    a {
        &, &:hover, &:active, &:visited {
            color: inherit;
            text-decoration: none;
        }
    }
}
</style>


// WEBPACK FOOTER //
// CourseCountdown.vue?4737bf3c